import {
  createReqConsts,
  createActions,
  createReqReducer,
  createReqWatcher,
} from '../../utils/redux';

export const consts = createReqConsts('circles', 'inviteCaregiverFamily');
export const actions = createActions(consts);
export const watcher = createReqWatcher(consts, actions, {
  endpoint: 'users',
  type: 'post',
  slug: [
    {
      type: 'payload',
      selector: ['id'],
    },
    'caregivers',
  ],
});

export default createReqReducer(consts);



// WEBPACK FOOTER //
// ./src/redux/circles/inviteCaregiverFamily.js